import {
  ReportChartGroupCompareConfig,
  ReportChartGroupCompareItemType,
  ReportChartGroupItemMeasure,
  ReportChartGroupItemType,
  ReportChartMeasureType,
} from '@vision/ui/interfaces';

export const INNER_LOOP_CHART_TYPES: ReportChartGroupItemType[] = [
  'trend-chart-1',
  'trend-chart-4',
  'bar-chart-1',
  'bar-chart-2',
  'bar-chart-4',
  'bar-chart-5',
  'pie-chart-1',
  'pie-chart-3',
  'table-chart-1',
  'card-chart-1',
];

export const INNER_LOOP_TREND_CHART_TYPES: ReportChartGroupItemType[] = ['trend-chart-1', 'trend-chart-4'];

export const INNER_LOOP_MEASURES: ReportChartMeasureType[] = [
  'ticket-count',
  'ticket-reopen-count',
  'ticket-reopen-rate',
  'ticket-average-time-to-first-resolution',
  'ticket-average-time-in-status',
  'ticket-average-time-to-latest-resolution',
];

export const INNER_LOOP_MEASUREMENT_GROUPS: ReportChartGroupItemMeasure[] = [
  { type: 'ticket', items: INNER_LOOP_MEASURES },
];

export const INNER_LOOP_COMPARES: ReportChartGroupCompareItemType[] = [
  'ticket-status',
  'ticket-priority',
  'ticket-root-cause',
  'ticket-pool',
  'ticket-team',
  'ticket-assignee',
  'ticket-channel',
  'ticket-project',
  'ticket-created-date',
  'ticket-closed-date',
];

export const INNER_LOOP_TEMPORAL_COMPARES: ReportChartGroupCompareItemType[] = [
  'ticket-created-date',
  'ticket-closed-date',
];

export const INNER_LOOP_COMPARE_CONFIG: ReportChartGroupCompareConfig[] = [
  {
    charts: [...INNER_LOOP_TREND_CHART_TYPES, 'table-chart-1'],
    measures: INNER_LOOP_MEASURES,
    compareItems: [{ type: 'ticket', items: INNER_LOOP_TEMPORAL_COMPARES }],
  },
  {
    charts: INNER_LOOP_CHART_TYPES.filter(
      (chartType) => !INNER_LOOP_TREND_CHART_TYPES.includes(chartType) && chartType !== 'table-chart-1',
    ),
    measures: INNER_LOOP_MEASURES,
    compareItems: [{ type: 'ticket', items: INNER_LOOP_COMPARES }],
  },
];
